import { SettingsRoutes } from 'pages/settings/route/type'
import { urlShortenerRoutes } from './type'

const root = `${SettingsRoutes.root}/${SettingsRoutes.organization}/${urlShortenerRoutes.root}`

export const UrlShortenerPath = {
  root: root,
}
